// extracted by mini-css-extract-plugin
export var text = "_86-0";